import { ResumeAdminFindOneDto, Pagination, PaginationQuery } from '@libs/dto';
import { Resume } from '@libs/models';
import { api } from '../common.api';

export const resumeAdminApi = api.injectEndpoints({
  endpoints: (build) => ({
    resumeAdminSearch: build.query<Pagination<Resume>, PaginationQuery>({
      query: ({ q = '', page = 1, limit = 20 }) => ({
        url: '/admin/resumes/search',
        method: 'GET',
        params: { term: q, page, limit },
      }),
      providesTags: ['Resume'],
    }),

    resumeAdminFindOne: build.query<ResumeAdminFindOneDto, string>({
      query: (id) => ({
        url: `/admin/resumes/${id}`,
        method: 'GET',
      }),
      providesTags: ['Resume'],
    }),
  }),
});

export const {
  useResumeAdminSearchQuery,
  useLazyResumeAdminSearchQuery,
  useResumeAdminFindOneQuery,
  useLazyResumeAdminFindOneQuery,
} = resumeAdminApi;
